import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, Button, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { Blog } from '../../interfaces/Blog/Blog';
import { getBlogs } from '../../api/Blog';
import { sharedStyles } from '../../utils/Style';
import { Waiting } from '../../components/Waiting/Waiting';
import { BlogsTable } from './BlogsTable';

export const BlogsPage = () => {
  const navigate = useNavigate();

  const [blogs, setBlogs] = useState<Blog[]>([]);
  const [loading, setLoading] = useState(false);

  const refreshBlogs = () => {
    setLoading(true);
    getBlogs()
      .then((b) => setBlogs(b))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(refreshBlogs, []);

  return (
    <Box sx={{ ...sharedStyles.pageBody }}>
      <Typography variant='h5' sx={{ ...sharedStyles.pageTitle }}>
        Blog
      </Typography>
      <Waiting open={loading} />
      <Button
        variant='contained'
        startIcon={<AddIcon />}
        onClick={() => navigate('/blogs/blogs/new')}
        sx={{ ...sharedStyles.buttonText, mb: 1.5 }}
      >
        Yeni Blog
      </Button>
      <BlogsTable blogs={blogs} />
    </Box>
  );
};
